import * as React from "react"

function useSSR() {
  const [isSSR, setIsSSR] = React.useState(true)

  React.useEffect(() => {
    setIsSSR(false)
  }, [])

  return isSSR
}

export function useLockScroll(initial = false) {
  const isSSR = useSSR()
  const [isLocked, setIsLocked] = React.useState(initial)
  const originalOverflowRef = React.useRef<string | null>(null)

  React.useEffect(() => {
    if (isSSR) return

    const bodyStyle = document.body.style

    if (isLocked) {
      if (!originalOverflowRef.current) {
        originalOverflowRef.current = window.getComputedStyle(document.documentElement).overflow
      }
      bodyStyle.overflow = "hidden"
    } else {
      resetStyles(bodyStyle, originalOverflowRef.current)
    }

    return () => {
      resetStyles(bodyStyle, originalOverflowRef.current)
    }
  }, [isLocked, isSSR])

  const toggleLock = React.useCallback(() => {
    setIsLocked((prevState) => !prevState)
  }, [])

  return { isLocked, setIsLocked, toggleLock }
}

function resetStyles(bodyStyle: CSSStyleDeclaration, originalStyle: string | null) {
  bodyStyle.overflow = originalStyle || "auto"
}
